import {
    Container,
    Graphics,
} from 'pixi.js';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../GameConst';
import { InfoTextBar } from '../../components/InfoTextBar';
import { LayerNameBar } from './LayerNameBar';
import { userDataManager } from '../../utils/UserDataManager';
import { CardObject } from '../../components/CardObject';
import { ShurikenObject } from '../BattleScene/ShurikenObject';
import { ScrollBox } from '@pixi/ui';
import { CardData } from '../../components/CardData';
import { CommonButton, ON_BUTTON_EVENT } from '../../components/CommonButton';
import { postAPI } from '../../utils/API';

const deckNumber = 1;

export class DeckEditLayer extends Container {
    constructor(){
        super();

        const background = new Graphics();
        background.beginFill(0x9b7e5a);
        background.drawRect(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);
        background.endFill();
        background.eventMode = 'static';
        this.addChild(background);

        const layerNameBar = new LayerNameBar('デッキ編成', true);
        this.addChild(layerNameBar);
        layerNameBar.y -= SCREEN_HEIGHT * 0.14;

        this.deckContainer = new Container();
        this.deckContainer.x = SCREEN_WIDTH * 0.15;
        this.deckContainer.y = SCREEN_HEIGHT * 0.2;

        this.deckSlotContainers = [];
        for(let i = 0; i < 5; i++){
            const slotContainer = new CommonButton();
            slotContainer.x = i * SCREEN_WIDTH * 0.15;
            slotContainer.scale.set(0.4);
            this.deckSlotContainers.push(slotContainer);
            this.deckContainer.addChild(slotContainer);
            slotContainer.on(ON_BUTTON_EVENT, () => {
                this.cardsScrollBox.visible = true;
                this.shurikensScrollBox.visible = false;
                this.onSelectDeckSlot(i + 1);
            });
        }
        this.deckShurikenContainer = new CommonButton();
        this.deckShurikenContainer.x = 5 * SCREEN_WIDTH * 0.15;
        this.deckShurikenContainer.scale.set(0.5);
        this.deckContainer.addChild(this.deckShurikenContainer);
        this.deckShurikenContainer.on(ON_BUTTON_EVENT, () => {
            this.cardsScrollBox.visible = false;
            this.shurikensScrollBox.visible = true;
            this.onSelectDeckSlot(0);
        });

        this.addChild(this.deckContainer);
        this.cardsScrollBox = new ScrollBox({
            // background: 0XFFFFFF,
            elementsMargin: 10,
            width: SCREEN_WIDTH * 0.9 + 20,
            height: SCREEN_HEIGHT * 0.6,
            radius: 0,
            padding: 10,
            disableEasing: false,
            disableDynamicRendering: true,
        });
        this.addChild(this.cardsScrollBox );
        this.cardsScrollBox.x = SCREEN_WIDTH * 0.5 - this.cardsScrollBox.width * 0.5 + 30;
        this.cardsScrollBox.y = SCREEN_HEIGHT * 0.3;
        this.cardsScrollBox.visible = true;

        this.shurikensScrollBox = new ScrollBox({
            // background: 0XFFFFFF,
            elementsMargin: 10,
            width: SCREEN_WIDTH * 0.9 + 20,
            height: SCREEN_HEIGHT * 0.6,
            radius: 0,
            padding: 10,
            disableEasing: false,
            disableDynamicRendering: true,
        });
        this.addChild(this.shurikensScrollBox );
        this.shurikensScrollBox.x = SCREEN_WIDTH * 0.5 - this.shurikensScrollBox.width * 0.5 + 30;
        this.shurikensScrollBox.y = SCREEN_HEIGHT * 0.3;
        this.shurikensScrollBox.visible = false;

        this.currentDeckNumber = 1;
        this.selectedDeckSlot = 0;
        this.currentDeckOnchainCardIds = [];
        this.currentDeckReplicaCardIds = [];
        this.onchainCardIdObjectContainerMap = {};
        this.replicaCardIdObjectContainerMap = {};
        this.shurikenIdObjectContainerMap = {};

        this.setCurrentDeck(this.currentDeckNumber);

        this.setAllCardsObject();
        this.setAllShurikensObject();
    }

    setCurrentDeck(number)
    {
        this.selectedDeckSlot = 0;
        const deck = userDataManager.getDeck(number);
        this.currentDeck = deck;
        this.currentDeckOnchainCardIds = deck.cards.filter(card => !card.isReplica).map(card => card.mCardId);
        this.currentDeckReplicaCardIds = deck.cards.filter(card => card.isReplica).map(card => card.mCardId);
        for(let i = 0; i < 5; i++){
            const container = this.deckSlotContainers[i];
            const cardData = userDataManager.getDeckCardData(deckNumber, i + 1);
            this.initDeckCardDataAndSetCardObjectAsync(cardData, container);
        }
        this.currentDeckShuriken = userDataManager.getDeckShurikenData(deckNumber);
        const shuriken = new ShurikenObject(1, this.currentDeckShuriken);
        this.deckShurikenContainer.children.forEach(child => child.destroy({children:true}));
        this.deckShurikenContainer.addChild(shuriken);
    }

    onSelectDeckSlot(slot)
    {
        this.selectedDeckSlot = slot;
        for(let i = 0; i < 5; i++){
            const container = this.deckSlotContainers[i];
            const cardObject = container.children[0];
            cardObject.select((i + 1) == slot);
        }
    }

    async initDeckCardDataAndSetCardObjectAsync(cardData, container)
    {
        await cardData.Init();
        const cardObject = new CardObject(true, cardData);
        // container内のオブジェクトを全削除してから追加
        container.children.forEach(child => child.destroy({children:true}));
        container.addChild(cardObject);
    }

    async setAllCardsObject()
    {
        this.allCards = [];
        this.allCards.push(...userDataManager.OnchainCards, ...userDataManager.ReplicaCards);
        this.cardDatas = [];
        this.allCards.forEach(card => {
            const isOnchain = !!card.tokenId;
            const cardData = isOnchain ? CardData.CreateOnchainCardData(card, 1) : CardData.CreateReplaceCardData(card, 1);
            this.cardDatas.push(cardData);
        });
        await Promise.all(this.cardDatas.map(cardData => cardData.Init()));
        this.allCards.forEach((card, index) => {
            const isOnchain = !!card.tokenId;
            const cardData = this.cardDatas[index];
            const cardObject = new CardObject(true, cardData);
            cardObject.pivot.set(cardObject.width * -0.5, cardObject.height * -0.5);
            cardObject.scale.set(0.6);
            const button = new CommonButton(cardObject, {ignorePivot:true});
            button.on(ON_BUTTON_EVENT, () => {
                this.sendSetSlotCard(!isOnchain, card.id);
            });
            this.cardsScrollBox.addItem(button);
            if(isOnchain)
            {
                this.onchainCardIdObjectContainerMap[card.id] = button;
            }
            else
            {
                this.replicaCardIdObjectContainerMap[card.id] = button;
            }
        });
        this.updateSelectionCards();
    }

    async setAllShurikensObject()
    {
        userDataManager.Shurikens.forEach(shuriken => {
            const shurikenObject = new ShurikenObject(1, shuriken);
            shurikenObject.pivot.set(shurikenObject.width * -0.5, shurikenObject.height * -0.5);
            shurikenObject.scale.set(0.8);
            const button = new CommonButton(shurikenObject, {ignorePivot:true});
            this.shurikensScrollBox.addItem(button);
            this.shurikenIdObjectContainerMap[shuriken.id] = button;
            button.on(ON_BUTTON_EVENT, () => {
                this.sendSetShuriken(shuriken.id);
            });
        });
        this.updateSelectionShurikens();
    }

    updateSelectionCards()
    {
        Object.keys(this.onchainCardIdObjectContainerMap).forEach(cardId => {
            const buttonObject = this.onchainCardIdObjectContainerMap[cardId];
            buttonObject.children[0].select(-1 != this.currentDeckOnchainCardIds.indexOf(cardId));
        });
        Object.keys(this.replicaCardIdObjectContainerMap).forEach(cardId => {
            const buttonObject = this.replicaCardIdObjectContainerMap[cardId];
            buttonObject.children[0].select(-1 != this.currentDeckReplicaCardIds.indexOf(cardId));
        });
    }

    updateSelectionShurikens()
    {
        Object.keys(this.shurikenIdObjectContainerMap).forEach(shurikenId => {
            const buttonObject = this.shurikenIdObjectContainerMap[shurikenId];
            buttonObject.children[0].select(this.currentDeckShuriken.id == shurikenId);
        });
    }

    async sendSetSlotCard(isReplica, mCardId)
    {
        if(this.isWaitApi) return;
        if(!this.selectedDeckSlot) return;
        if(isReplica)
        {
            if(-1 != this.currentDeckReplicaCardIds.indexOf(mCardId)) return;
        }
        else
        {
            if(-1 != this.currentDeckOnchainCardIds.indexOf(mCardId)) return;
        }
        this.isWaitApi = true;
        const result = await postAPI(`/decks/${this.currentDeckNumber}/slots/${this.selectedDeckSlot}`, [
            ['isReplica', isReplica],
            ['mCardId', mCardId],
        ]);
        if(!result){
            console.error('ERROR');
            this.isWaitApi = false;
            return;
        }
        userDataManager.updateUserData(result);
        this.isWaitApi = false;
        this.setCurrentDeck(this.currentDeckNumber);
        this.updateSelectionCards();
    }

    async sendSetShuriken(id)
    {
        if(this.isWaitApi) return;
        if(this.currentDeckShuriken.id == id) return;
        this.isWaitApi = true;
        const result = await postAPI(`/decks/${this.currentDeckNumber}/shuriken`, [
            ['id', id],
        ]);
        if(!result){
            console.error('ERROR');
            this.isWaitApi = false;
            return;
        }
        userDataManager.updateUserData(result);
        this.isWaitApi = false;
        this.setCurrentDeck(this.currentDeckNumber);
        this.updateSelectionShurikens();
    }
}
